import React, { useEffect, useState } from "react";
import { AGENT_OUTGOING_CALL } from "../../constants";
import axios from "axios";
import dayjs from "dayjs";
import { Box, IconButton, Tab, Tabs, Typography } from "@mui/material";
import ConnectedCallTable from "./CallingRequiredComponent/OutgoinCallTabs/ConnectedCallTable";
import FilterComponent from "./FilterCompoenent";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FilterListIcon from "@mui/icons-material/FilterList";
import NotConnectedCallTable from "./CallingRequiredComponent/OutgoinCallTabs/NotConnectedCallTable";
import Loader from "../reusable Component/Loader";
import {AGENT_OUTGOING_CALL_COUNTS,OUTGOING_CONNECTED_CALL,OUTGOING_MISSED_CALL} from '../../constants'

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};



function OutgoingCallAgent() {

      const [loading, setLoading] = useState(false);
        const Local_EmployeePhone = JSON.parse(localStorage.getItem('userData')).EmployeePhone;

          const [refetchToggle, setRefetchToggle] = useState(false)
        
        
      const [filters, setFilters] = useState({
        startDate: dayjs().subtract(7, "days").format("YYYY-MM-DD"), // 7 days ago
        endDate: dayjs().format("YYYY-MM-DD"),
        page: 1,
    pageSize: 10
        // Today
      });


      // FOR PAGINATION ------------------------>

 

    
      const [metricData, setMetricData] = useState([]);

       const [tabValues, setTabValues] = useState(0); // Default to the first tab
          const [openSnackbar, setOpenSnackbar] = useState(false);
             const [severity, setSeverity] = useState("");
             const [message, setMessage] = useState("");
             
       const [outgoing,setOutgoing] = useState(null);
       const [outgoingConnected,setOutgoingConnected] = useState(null);
       const [outgoingMissed,setOutgoingMissed] = useState(null);

        const agent = JSON.parse(localStorage.getItem("userData"));
  const agentNumber = agent?.EmployeePhone;

  const [missedFilters, setMissedFilters] = useState({
      page: 1,
      pageSize: 10
    });
  const [connectedFilters, setConnectedFilters] = useState({
      page: 1,
      pageSize: 10
    });


      //  useEffect(() => {
      //     const fetchData = async () => {
      //       try {
      //         setLoading(true);        
      //        const [outgoingRes,connectedRes,missedRes] = await Promise.all([
      //   axios.get(
      //     `${AGENT_OUTGOING_CALL_COUNTS}?startDate=${filters.startDate}&endDate=${filters.endDate}&agentNumber=${agentNumber}`
      //     // `${AGENT_OUTGOING_CALL_COUNTS}?startDate=2025-07-30&endDate=2025-07-30&agentNumber=${agentNumber}`
      //   ),
      //   axios.get(`${OUTGOING_CONNECTED_CALL}?startDate=${filters.startDate}&endDate=${filters.endDate}&aPartyNo=${agentNumber}&page=${connectedPagination.page + 1}&pageSize=${connectedPagination.rowsPerPage}`),

      //   // axios.get(
      //   //   `${OUTGOING_CONNECTED_CALL}?startDate=${filters.startDate}&endDate=${filters.endDate}&aPartyNo=${agentNumber}`
      //   //   // `${AGENT_INCOMMING_CONNECTED_CALL}?startDate=2025-07-30&endDate=2025-07-30&aPartyNo=${agentNumber}`
      //   // ),
      //   axios.get(`${OUTGOING_MISSED_CALL}?startDate=${filters.startDate}&endDate=${filters.endDate}&aPartyNo=${agentNumber}&page=${missedPagination.page + 1}&pageSize=${missedPagination.rowsPerPage}`)

      //   // axios.get(
      //   //   `${OUTGOING_MISSED_CALL}?startDate=${filters.startDate}&endDate=${filters.endDate}&aPartyNo=${agentNumber}`
      //   //   // `${AGENT_INCOMMING_CONNECTED_CALL}?startDate=2025-07-30&endDate=2025-07-30&aPartyNo=${agentNumber}`
      //   // ),
      // ]);
      //         setOutgoing(outgoingRes.data);
      //         setOutgoingConnected(connectedRes.data);
      //         setOutgoingMissed(missedRes.data);
      
      //       } catch (error) {
      //         console.error(error);
      //         setMessage("Error loading dashboard data");
      //         setSeverity("error");
      //         setOpenSnackbar(true);
      //       } finally {
      //         setLoading(false);
      //       }
      //     };
      
      //     if(filters.startDate && filters.endDate){
      //       fetchData();
      //     }
      //   }, [filters,agentNumber]);  // here agentNumber is not necessary but still i added it for safety

               // pagination state for each tab

useEffect(() => {
  const fetchCounts = async () => {
    try {
      if (!filters.startDate || !filters.endDate) return;

      const query = new URLSearchParams({
        startDate: filters.startDate,
        endDate: filters.endDate,
        agentNumber,
      }).toString();

      const res = await axios.get(`${AGENT_OUTGOING_CALL_COUNTS}?${query}`);
      setOutgoing(res.data);
    } catch (error) {
      console.error("Error fetching outgoing counts", error);
      setMessage("Error loading outgoing counts");
      setSeverity("error");
      setOpenSnackbar(true);
    }
  };

  fetchCounts();
}, [filters.startDate, filters.endDate, agentNumber]);

// 2️⃣ Fetch connected + missed calls (with pagination)
useEffect(() => {
  const fetchCalls = async () => {
    try {
      if (!filters.startDate || !filters.endDate) return;
      setLoading(true);

          const buildQueryforMissed  = (extraParams = {}) => {
        const query = new URLSearchParams({
          startDate: filters.startDate,
          endDate: filters.endDate,
          aPartyNo: agentNumber, // default for call details
          ...(missedFilters.page ? { page: missedFilters.page } : {}),
          ...(missedFilters.pageSize ? { pageSize: missedFilters.pageSize } : {}),
          ...extraParams,
        });
        return query.toString();
      };

      const buildQuery = (extraParams = {}) => {
        const query = new URLSearchParams({
          startDate: filters.startDate,
          endDate: filters.endDate,
          aPartyNo: agentNumber,
          ...(connectedFilters.page ? { page: connectedFilters.page } : {}),
          ...(connectedFilters.pageSize ? { pageSize: connectedFilters.pageSize } : {}),
          ...extraParams,
        });
        return query.toString();
      };

      const [connectedRes, missedRes] = await Promise.all([
        axios.get(`${OUTGOING_CONNECTED_CALL}?${buildQuery()}`),
        axios.get(`${OUTGOING_MISSED_CALL}?${buildQueryforMissed()}`),
      ]);

      setOutgoingConnected(connectedRes.data);
      setOutgoingMissed(missedRes.data);
    } catch (error) {
      console.error("Error fetching outgoing calls", error);
      setMessage("Error loading outgoing calls");
      setSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  fetchCalls();
}, [filters, agentNumber,missedFilters,connectedFilters]);


  
      
      
  console.log("outgoing",outgoing)
  console.log("outgoingConnected",outgoingConnected)
  console.log("outgoingMissed",outgoingMissed)

      
        // Handle tab change
        const handleTabChange = (event, newValue) => {
          setTabValues(newValue); // Update the current tab index
        };

        
          const [filterShow, setFilterShow] = useState(false);

            useEffect(() => {
            // Trigger refetch whenever filters change
            setRefetchToggle(prev => !prev);
          }, [filters]);
          
          useEffect(()=>{
                localStorage.removeItem("agentFilters");
        
          },[]);
      
  return (
    <>
          {loading && <Loader open={loading} />}

          
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: 700, paddingLeft: "12px", flexGrow: 1 }}
                  >
                    Outgoing Call Report
                  </Typography>
          
                  {/* IconButton aligned to the right */}
                  <IconButton
                    onClick={() => setFilterShow((prev) => !prev)}
                    style={{
                      border: "1px solid #fff", // Change border color to white for contrast
                      borderRadius: "4px",
                      margin: "5px",
                      width: "40px", // Increased width for a more comfortable click area
                      height: "40px", // Increased height for a more comfortable click area
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#097969",
                      color: "#fff",
                      transition: "background-color 0.3s, transform 0.2s", // Smooth transition effects
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Add shadow for depth
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#0B9B73"; // Darker shade on hover
                      e.currentTarget.style.transform = "scale(1.05)"; // Slightly scale up on hover
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#097969"; // Original color
                      e.currentTarget.style.transform = "scale(1)"; // Reset scale
                    }}
                  >
                    <FilterListIcon />
                  </IconButton>
          
                  {/* IconButton aligned to the right */}
                  {/* <IconButton
                  //   onClick={handleExport}
                    style={{
                      border: "1px solid #fff", // Change border color to white for contrast
                      borderRadius: "4px",
                      margin: "5px",
                      width: "40px", // Increased width for a more comfortable click area
                      height: "40px", // Increased height for a more comfortable click area
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#097969",
                      color: "#fff",
                      transition: "background-color 0.3s, transform 0.2s", // Smooth transition effects
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Add shadow for depth
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#0B9B73"; // Darker shade on hover
                      e.currentTarget.style.transform = "scale(1.05)"; // Slightly scale up on hover
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#097969"; // Original color
                      e.currentTarget.style.transform = "scale(1)"; // Reset scale
                    }}
                  >
                    <FileDownloadIcon />
                  </IconButton> */}
                </Box>

                
                      {filterShow && (
                        <FilterComponent
                          filters={filters}
                          setFilters={setFilters}
                          setFilterShow={setFilterShow}
                                    Local_EmployeePhone={Local_EmployeePhone}

                        ></FilterComponent>
                      )}

                       <Box
                              display="flex"
                              justifyContent="space-between"
                              gap="16px"
                              sx={{
                                padding: "16px",
                                backgroundColor: "#EEF0F4",
                                borderRadius: "8px",
                                marginBottom: "16px",
                              }}
                            >
                              {/* Total Calls */}
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  padding: "8px",
                                  backgroundColor: "#FFFFFF",
                                  borderRadius: "8px",
                                  boxShadow: 2,
                                  width: "30%",
                                }}
                              >
                                <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
                                  Total Calls
                                </Typography>
                                <Typography
                                  variant="h6"
                                  sx={{ fontWeight: "bold", color: "#333333" }}
                                >
                                  {outgoing?.summary?.totalCalls || 0}
                                </Typography>
                              </Box>
                      
                              {/* Connected Calls */}
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  padding: "8px",
                                  backgroundColor: "#FFFFFF",
                                  borderRadius: "8px",
                                  boxShadow: 2,
                                  width: "30%",
                                }}
                              >
                                <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
                                  Connected Calls
                                </Typography>
                                <Typography
                                  variant="h6"
                                  sx={{ fontWeight: "bold", color: "#333333" }}
                                >
                                  {outgoing?.summary?.connectedCalls || 0}
                                </Typography>
                              </Box>
                      
                              {/* Missed Calls */}
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  padding: "8px",
                                  backgroundColor: "#FFFFFF",
                                  borderRadius: "8px",
                                  boxShadow: 2,
                                  width: "30%",
                                }}
                              >
                                <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
                                  Not-Connected Calls
                                </Typography>
                                <Typography
                                  variant="h6"
                                  sx={{ fontWeight: "bold", color: "#333333" }}
                                >
                                  {outgoing?.summary?.notConnectedCalls || 0}
                                </Typography>
                              </Box>
                      
                              {/* Total Talk time */}
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  padding: "8px",
                                  backgroundColor: "#FFFFFF",
                                  borderRadius: "8px",
                                  boxShadow: 2,
                                  width: "30%",
                                }}
                              >
                                <Typography variant="body2" sx={{ color: "#7A7A7A" }}>
                                  Total Connected Time
                                </Typography>
                                <Typography
                                  variant="h6"
                                  sx={{ fontWeight: "bold", color: "#333333" }}
                                >
                                   {outgoing?.summary?.totalConnectedDuration || 0}
                                </Typography>
                              </Box>
                            </Box>
           <Tabs
                 value={tabValues} // Current selected tab
                 onChange={handleTabChange} // Handle tab change
                 aria-label="Call Statistics Tabs"
               >
                 {/* Tab for Connected Calls */}
                 <Tab
                   label={`Connected (${outgoingConnected?.connectedCallCount || 0})`}
                   id="tab-0"
                   aria-controls="tabpanel-0"
                 />
                 {/* Tab for Missed Calls */}
                 <Tab
                   label={`Not-Connected (${outgoingMissed?.missedCallCount || 0})`}
                   id="tab-1"
                   aria-controls="tabpanel-1"
                 />
               </Tabs>   

               
      {/* Tab Panels */}
      <TabPanel value={tabValues} index={0}>
        <ConnectedCallTable
          filters={filters}
          connectedFilters={connectedFilters}
          setConnectedFilters={setConnectedFilters}
          setFilters={setFilters}
          setLoading={setLoading}
          outgoingConnected={outgoingConnected}
        />
      </TabPanel>
      <TabPanel value={tabValues} index={1}>
        <NotConnectedCallTable
          filters={filters}
          setFilters={setFilters}
           missedFilters={missedFilters}
          setMissedFilters={setMissedFilters}
          setLoading={setLoading}
          outgoingMissed={outgoingMissed}
        />
      </TabPanel>    

    </>
  )
}

export default OutgoingCallAgent